import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Root extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Root';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'school', 'root', 'phone', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'root',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/super-adminstrators/' + this.id;
    }
}
